import React, { useEffect, useState, useRef } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { Result, refillLimitDrugs } from "../../interface/RefillLimitDrugs";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import { RefillLimitDrugsAxiosInstance } from "../../Network/RefillLimitDrugsAxiosInstance";
import { Option } from "../../interface/Option";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import DataTable2 from "shared/DataTable2";
import ListOfNewNetworkName from "../Shared/NewNetworkName";
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import ListOfBenefitGroup from "../Shared/ListOfBenefitGroup";
import ListOfDrugCode from "../Shared/DrugCode";
import ListOfDrugMedical from "../Shared/DrugMedicalGroup";
import ListOfDrugCustom from "../Shared/DrugCustomGroup";
import Patient from "../Shared/Patient";
import ListOfProviderName from "../Shared/ListOfProviderName";
import PolicyNames from "../Shared/PolicyNames";
import ListOfDoctorName from "../Shared/Doctor";
import FileUpload from "Pages/uploadFile/RefillLimitDrugs/RefillLimitDrugs";
const RefillLimitDrugs: React.FC = () => {
  // Main data state
  const [items, setItems] = useState<refillLimitDrugs>({ result: [] });
  //api

  // Form states
  const [Name, setName] = useState<string>("");
  const [DrugCode, setDrugCode] = useState<Option[]>([]);
  const [SupplyLimit, setSupplyLimit] = useState<number>(0);
  const [Dosage, setDosage] = useState<number>(0);
  const [frequencyType, setFrequencyType] = useState<string>("daily");
  const [DispensedDate, setDispensedDate] = useState<string>("");
  const [refillLimit, setRefillLimit] = useState<number>(0);
  const [customDrugGroups, setCustomDrugGroups] = useState<Option[]>([]);
  const [medicalDrugGroups, setMedicalDrugGroups] = useState<Option[]>([]);
  const [provider, setProvider] = useState<Option[]>([]);
  const [applyToOtherProviders, setApplyToOtherProviders] =
    useState<boolean>(false);
  const [networks, setNetworks] = useState<Option[]>([]);
  const [apply_to_other_networks, setApply_to_other_networks] =
    useState<boolean>(false);
  const [policy, setPolicy] = useState<Option[]>([]);
  const [apply_to_other_policy, setApply_to_other_policy] =
    useState<boolean>(false);
  const [insuranceplan, setInsuranceplan] = useState<Option[]>([]);
  const [apply_to_other_insuranceplan, setapply_to_other_insuranceplan] =
    useState<boolean>(false);
  const [Payer, setPayer] = useState<string[]>([]);
  const [apply_to_other_payer, setapply_to_other_payer] =
    useState<boolean>(false);
  const [patients, setPatients] = useState<Option[]>([]);
  const [apply_to_other_patients, setApply_to_other_patients] =
    useState<boolean>(false);
  const [userLevel, setUserLevel] = useState<string[]>([]);
  const [apply_to_other_user, setApply_to_other_user] =
    useState<boolean>(false);
  const [apply_to_other_vip, setApply_to_other_vip] = useState<boolean>(false);
  const [doctor, setDoctor] = useState<Option[]>([]);
  const [applyToOtherDoctor, setApplyToOtherDoctor] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(true);
  // UI control states
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [clearDrugCode, setClearDrugCode] = useState(false);
  const [clearNetworks, setClearNetworks] = useState(false);
  const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [clearPolicy, setClearPolicy] = useState(false);
  const [clearProvider, setClearProvider] = useState(false);
  const [clearPatient, setClearPatient] = useState(false);
  const [clearDoctor, setClearDoctor] = useState(false);

  const [clearCustomDrugGroups, setClearCustomDrugGroups] = useState(false);
  const [clearMedicalDrugGroups, setClearMedicalDrugGroups] = useState(false);
  const [selectedDrugOption, setSelectedDrugOption] = useState<string | null>(
    null
  );
  const [selectedItem, setSelectedItem] = useState<Result | null>(null);
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  // class css for apply
  const hasSelectValue = !!selectedDrugOption;
  // Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

  const clear = () => {
    setName("");
    setDrugCode([]);
    setSupplyLimit(0);
    setDosage(0);
    setFrequencyType("daily");
    setDispensedDate("");
    setProvider([]);
    setApplyToOtherProviders(false);
    setNetworks([]);
    setApply_to_other_networks(false);
    setInsuranceplan([]);
    setapply_to_other_insuranceplan(false);
    setPayer([]);
    setapply_to_other_payer(false);
    setPatients([]);
    setApply_to_other_patients(false);
    setApply_to_other_vip(false);
    setApply_to_other_policy(false);
    setApply_to_other_user(false);
    setPolicy([]);
    setUserLevel([]);
    setCustomDrugGroups([]);
    setMedicalDrugGroups([]);
    setRefillLimit(0);
    setSelectedDrugOption(null);
    setDoctor([]);
    setApplyToOtherDoctor(false);
    setIsActive(true);
  };
  useEffect(() => {
    fetchItems();
  }, []);

  const handleOpenDialog = (item: Result) => {
    setSelectedItem(item);
    dialogRef.current?.showModal();
  };

  const handleCloseDialog = () => {
    dialogRef.current?.close();
    setSelectedItem(null);
  };
  const handleEditClick = (item: Result) => {
    handleEdit(item);
    setIsDialogOpen(true);
  };

  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true);
  };

  const handleDrugChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setDrugCode(selectedOptions);
  };
  const handleInsuranceplanChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setInsuranceplan(selectedOptions);
  };
  const handleNetworkChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setNetworks(selectedOptions);
  };
  const handleCustomDrugGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setCustomDrugGroups(selectedOptions);
  };

  const handleMedicalDrugGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setMedicalDrugGroups(selectedOptions);
  };
  const handlePoliciesChange = (selectedOptions: Option[]) => {
    setPolicy(selectedOptions);
  };
  const handlePatientChange = (selectedOptions: Option[]) => {
    setPatients(selectedOptions);
  };
  const handleProviderChange = (selectedOptions: Option[]) => {
    setProvider(selectedOptions);
  };
  const handleDoctorChange = (selectedOptions: Option[]) => {
    setDoctor(selectedOptions);
  };
  // API functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await RefillLimitDrugsAxiosInstance.get("getRefillDrugs");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
      toast({
        title: "Error",
        description: "Failed to fetch Refill Drugs",
        variant: "destructive",
      });
    }
  };

  const addItem = async (): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: " Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: " Name must be at least 3 characters long.",
        variant: "destructive",
      });
    }
    const ValuesDrugcode = DrugCode.map((option) => option.value);
    const ValuesDrugMedical = medicalDrugGroups.map((option) => option.value);
    const ValuesDrugCustom = customDrugGroups.map((option) => option.value);
    const ValuesNetwork = networks.map((option) => option.value);
    const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
    const ValuesPolicy = policy.map((option) => option.value);
    const ValuesPatient = patients.map((option) => option.value);
    const ValuesProvider = provider.map((option) => option.value);
    const ValuesDoctor = doctor.map((option) => option.value);
    try {
      const newGroupArray = {
        relation_name: Name,
        drugs: ValuesDrugcode,
        refill_limit: refillLimit,
        dispensed_date: DispensedDate,
        supply_days: SupplyLimit,
        dosage: Dosage,
        frequency_type: frequencyType,
        custom_groups: ValuesDrugCustom,
        medical_groups: ValuesDrugMedical,
        provider: ValuesProvider,
        apply_to_other_providers: applyToOtherProviders,
        networks: ValuesNetwork,
        apply_to_other_networks: apply_to_other_networks,
        policy: ValuesPolicy,
        apply_to_other_policy: apply_to_other_policy,
        insuranceplan: ValuesInsurancePlan,
        apply_to_other_insuranceplan: apply_to_other_insuranceplan,
        payer: Payer,
        apply_to_other_payer: apply_to_other_payer,
        patients: ValuesPatient,
        apply_to_other_patients: apply_to_other_patients,
        user_level: userLevel,
        apply_to_other_user: apply_to_other_user,
        apply_to_vip: apply_to_other_vip,
        is_active: isActive,
        doctor: ValuesDoctor,
        apply_to_other_doctor: applyToOtherDoctor,
        token: token,
      };

      console.log(newGroupArray);
      const response = await RefillLimitDrugsAxiosInstance.post(
        "addRefillDrugs",
        newGroupArray
      );
      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "New Relation Refill Drugs added successfully.",
        });
      } else {
        if (response.data.errors && response.data.errors.length > 0) {
          const errorDetails = response.data.errors[0];
          const errorMessage =
            errorDetails.error ||
            "Failed to add the group due to an unknown error.";
          toast({
            title: "Error",
            description: errorMessage,
          });
          console.log(errorMessage);
        } else {
          toast({
            title: "Error",
            description: response.data.error || "Failed to add the group.",
            variant: "destructive",
          });
          console.log(response.data.error);
        }
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
      console.error(error.response?.data?.error || error.message);
    }
  };

  const updateItem = async (id: string | number): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: " Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: " Name must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    const ValuesDrugMedical = medicalDrugGroups.map((option) => option.value);
    const ValuesDrugCustom = customDrugGroups.map((option) => option.value);
    const ValuesDrugcode = DrugCode.map((option) => option.value);
    const ValuesNetwork = networks.map((option) => option.value);
    const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
    const ValuesDoctor = doctor.map((option) => option.value);
    const ValuesPolicy = policy.map((option) => option.value);
    const ValuesPatient = patients.map((option) => option.value);
    const ValuesProvider = provider.map((option) => option.value);

    const updatedItem = {
      relation_name: Name,
      drugs: ValuesDrugcode,
      refill_limit: refillLimit,
      dispensed_date: DispensedDate,
      supply_days: SupplyLimit,
      dosage: Dosage,
      frequency_type: frequencyType,
      custom_groups: ValuesDrugCustom,
      medical_groups: ValuesDrugMedical,
      provider: ValuesProvider,
      apply_to_other_providers: applyToOtherProviders,
      networks: ValuesNetwork,
      apply_to_other_networks: apply_to_other_networks,
      policy: ValuesPolicy,
      apply_to_other_policy: apply_to_other_policy,
      insuranceplan: ValuesInsurancePlan,
      apply_to_other_insuranceplan: apply_to_other_insuranceplan,
      payer: Payer,
      apply_to_other_payer: apply_to_other_payer,
      patients: ValuesPatient,
      apply_to_other_patients: apply_to_other_patients,
      user_level: userLevel,
      apply_to_other_user: apply_to_other_user,
      apply_to_vip: apply_to_other_vip,
      is_active: isActive,
      doctor: ValuesDoctor,
      apply_to_other_doctor: applyToOtherDoctor,
      id: id,
      token: token,
    };

    console.log("updatedItem", updatedItem);

    try {
      const response = await RefillLimitDrugsAxiosInstance.put(
        `updateRefillDrugs`,
        updatedItem
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "Relation Refill Drugs updated successfully.",
        });
      }
    } catch (error: AxiosError | any) {
      console.error("Error during the request: ", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  };

  const deleteItem = async (id: string | number): Promise<void> => {
    try {
      const response: AxiosResponse =
        await RefillLimitDrugsAxiosInstance.delete(`deleteRefillDrugs/${id}`, {
          data: { token: token },
        });
      if (response.data.success) {
        console.log(
          "Refill Drugs Relation  deleted successfully:",
          response.data
        );
        fetchItems();
        toast({
          title: "Success",
          description: "Refill Drugs Relation deleted successfully.",
        });
      } else {
        toast({
          title: "Error",
          description:
            response.data.error || "Failed to delete Relation Refill Drugs.",
          variant: "destructive",
        });
        console.error("Error deleting Relation Refill Drugs:");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete Relation Refill Drugs.",
        variant: "destructive",
      });
    }
  };

  const handleEdit = (item: Result) => {
    const mapToOptions = (arr: (string | number)[]): Option[] =>
      arr.map((value) => ({
        value: value, // Actual value
        label: value.toString(), // The text that will appear in the Select
      }));

    setName(item.relation_name);
    setDrugCode(mapToOptions(item.drugs));
    setSupplyLimit(item.supply_days || 0);
    setRefillLimit(item.refill_limit || 0);
    setDispensedDate(new Date(item.dispensed_date).toISOString().split("T")[0]);
    setFrequencyType(item.frequency_type || "daily");
    setDosage(item.dosage || 0);
    const CustomDrugGroupsData = Array.isArray(item.custom_groups)
      ? item.custom_groups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];
    setCustomDrugGroups(
      CustomDrugGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process medical_Drug_groups fields
    const MedicalDrugGroupsData = Array.isArray(item.medical_groups)
      ? item.medical_groups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setMedicalDrugGroups(
      MedicalDrugGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Networks
    const networksData = Array.isArray(item.networks)
      ? item.networks.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setNetworks(
      networksData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );

    //Convert or process insuranceplan fields
    const insuranceplanData = Array.isArray(item.insuranceplan)
      ? item.insuranceplan.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setInsuranceplan(
      insuranceplanData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process BenefitGroup fields

    // Convert or process fields Providers
    const ProvidersData = Array.isArray(item.provider)
      ? item.provider.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setProvider(
      ProvidersData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Patients
    const PatientsData = Array.isArray(item.patients)
      ? item.patients.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setPatients(
      PatientsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process Policy fields
    const PolicyData = Array.isArray(item.policy)
      ? item.policy.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setPolicy(
      PolicyData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Doctors
    const DoctorsData = Array.isArray(item.doctor)
      ? item.doctor.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setDoctor(
      DoctorsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );

    setApplyToOtherDoctor(item.apply_to_other_doctor);
    setIsActive(item.is_active);
    setApplyToOtherProviders(item.apply_to_other_providers);
    setApply_to_other_networks(item.apply_to_other_networks);
    setapply_to_other_insuranceplan(item.apply_to_other_insuranceplan);
    setPayer(item.payer);
    setapply_to_other_payer(item.apply_to_other_payer);
    setApply_to_other_patients(item.apply_to_other_patients);
    setApply_to_other_policy(item.apply_to_other_policy);
    setApply_to_other_user(item.apply_to_other_user);
    setApply_to_other_vip(item.apply_to_vip);
    setUserLevel(item.user_level);
    setEditIndex(item.id);
  };

  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <button onClick={() => handleOpenDialog(item)} className="id-button">
            {item.id}
          </button>
        );
      },
    },
    {
      accessorKey: "relation_name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "drugs",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Drug Code
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Activity = row.getValue("drugs") as string[];
        return Array.isArray(Activity) ? Activity.join(", ") : Activity;
      },
    },

    {
      accessorKey: "refill_limit",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Refill Limit
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
  ];

  return (
    <div className=" h5-container mx-auto p-8">
      <h5
        className="mb-6 flex items-center gap-2"
        style={{ fontWeight: "bolder", fontSize: "22px", marginTop: "15px" }}
      >
        <span className="icon-container">
          <i className="fa-solid fa-stop-circle"></i>
        </span>
        Refill Limit Drugs
      </h5>
      <FileUpload fetchItems={fetchItems} />

      {Boolean(selectedItem) && (
        <dialog ref={dialogRef} className="custom-dialog" open>
          {selectedItem && (
            <div className="dialog-content">
              {/* top-dialog-close-icon */}
              <button className="dialog-close-icon" onClick={handleCloseDialog}>
                ×
              </button>
              {/* dialog-title */}
              <h2 className="dialog-title">
                <span>Details for ID:</span> {selectedItem.id}
              </h2>
              {/* Content */}
              <div className="dialog-grid">
                <div className="dialog-row single-row">
                  <div className="dialog-item">
                    <strong>Relation Name:</strong>{" "}
                    <span>{selectedItem.relation_name}</span>
                  </div>
                </div>

                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong>Drug Code:</strong>
                    <p>{selectedItem.drugs.join(", ")}</p>
                  </div>
                  <div className="dialog-item">
                    <strong>Medical Drug Groups:</strong>
                    <p>
                      {selectedItem.medical_groups
                        .map((n) => n.name)
                        .join(", ")}
                    </p>
                  </div>
                  <div className="dialog-item">
                    <strong>Custom Drug Groups:</strong>
                    <p>
                      {selectedItem.custom_groups.map((n) => n.name).join(", ")}
                    </p>
                  </div>
                </div>
                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong>Refill Limit</strong>
                    <p>{selectedItem.refill_limit}</p>
                  </div>
                  <div className="dialog-item">
                    <strong>Dosge:</strong>
                    <p>{selectedItem.dosage}</p>
                  </div>
                  <div className="dialog-item">
                    <strong>Quantity Supplied:</strong>
                    <p>{selectedItem.supply_days}</p>
                  </div>
                </div>

                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong>Dispensed Date:</strong>
                    <p>
                      {
                        new Date(selectedItem.dispensed_date)
                          .toISOString()
                          .split("T")[0]
                      }
                    </p>
                  </div>

                  <div className="dialog-item">
                    <strong>End Date:</strong>
                    <p>
                      {
                        new Date(selectedItem.enddate)
                          .toISOString()
                          .split("T")[0]
                      }
                    </p>
                  </div>

                  <div className="dialog-item">
                    <strong>Frequency Type:</strong>{" "}
                    <span>{selectedItem.frequency_type}</span>
                  </div>
                </div>

                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Networks:</strong>{" "}
                    <span>
                      {selectedItem.networks.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply TO Other Networks:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_networks)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Insurance Plan:</strong>{" "}
                    <span>
                      {selectedItem.insuranceplan.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other Insurance Plan :
                    </strong>{" "}
                    <span>
                      {String(selectedItem.apply_to_other_insuranceplan)}
                    </span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Payers:</strong>{" "}
                    <span>{selectedItem.payer.join(", ")}</span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other Payers:
                    </strong>{" "}
                    <span>{String(selectedItem.apply_to_other_payer)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Provider:</strong>{" "}
                    <span>
                      {selectedItem.provider.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply TO Other Providers:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_providers)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Policy:</strong>{" "}
                    <span>
                      {selectedItem.policy.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Policy:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_policy)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Patients:</strong>{" "}
                    <span>
                      {selectedItem.patients.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Patients:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_patients)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>User Level:</strong>{" "}
                    <span>{selectedItem.user_level.join(", ")}</span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other User Level:
                    </strong>{" "}
                    <span>{String(selectedItem.apply_to_other_user)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Doctor:</strong>{" "}
                    <span>
                      {selectedItem.doctor.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Doctors:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_doctor)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Apply To VIP:</strong>{" "}
                    <span>{String(selectedItem.apply_to_vip)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Is Active:</strong>{" "}
                    <span>{String(selectedItem.is_active)}</span>
                  </div>
                </div>
              </div>
              <button className="dialog-close-btn" onClick={handleCloseDialog}>
                Close
              </button>
            </div>
          )}
        </dialog>
      )}

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null ? "Add Refill Limit" : "Edit Refill Limit"}
            </DialogTitle>
            <DialogDescription>
              Fill in the details below to{" "}
              {editIndex === null ? "create" : "update"} a Refill Limit.
            </DialogDescription>
          </DialogHeader>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <div className="mb-4">
                <Label htmlFor="name">Relation Name</Label>
                <Input
                  id="relation name"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Relation Name is required"
                />
              </div>
              <div className="mb-4">
                <Label htmlFor="refillLimit">Refill Limit</Label>
                <Input
                  id="refillLimit"
                  value={refillLimit}
                  onChange={(e) => setRefillLimit(Number(e.target.value))}
                  placeholder="Enter Refill Limit"
                />
              </div>
              <div className="mb-4">
                <Label htmlFor="dosage">Dosage</Label>
                <Input
                  id="Dosage"
                  value={Dosage}
                  onChange={(e) => setDosage(Number(e.target.value))}
                  placeholder="Enter Dosage"
                />
              </div>
              <div className="mb-4">
                <Label htmlFor="main_diagnoses"> Drug:</Label>

                <Select onValueChange={(value) => setSelectedDrugOption(value)}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select an option" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="list_of_Drug_code">
                      List of Drug Code
                    </SelectItem>
                    <SelectItem value="medical_Drug_groups">
                      Medical Drug Groups
                    </SelectItem>
                    <SelectItem value="custom_Drug_groups">
                      Custom Drug Groups
                    </SelectItem>
                  </SelectContent>
                </Select>

                {selectedDrugOption === "list_of_Drug_code" && (
                  <div className="mt-2">
                    <ListOfDrugCode
                      onChange={handleDrugChange}
                      defaultValue={DrugCode}
                      clear={clearDrugCode}
                    />
                  </div>
                )}

                {selectedDrugOption === "medical_Drug_groups" && (
                  <div className="mt-2">
                    <ListOfDrugMedical
                      onChange={handleMedicalDrugGroupsChange}
                      defaultValue={medicalDrugGroups}
                      clear={clearMedicalDrugGroups}
                    />
                  </div>
                )}

                {selectedDrugOption === "custom_Drug_groups" && (
                  <div className="mt-2">
                    <ListOfDrugCustom
                      onChange={handleCustomDrugGroupsChange}
                      defaultValue={customDrugGroups}
                      clear={clearCustomDrugGroups}
                    />
                  </div>
                )}
              </div>

              <div className="mb-4">
                <Label>Providers:</Label>
                <ListOfProviderName
                  onChange={handleProviderChange}
                  defaultValue={provider}
                  clear={clearProvider}
                />
              </div>
              <div className="mb-4">
                <Label>Networks:</Label>
                <ListOfNewNetworkName
                  onChange={handleNetworkChange}
                  defaultValue={networks}
                  clear={clearNetworks}
                />
              </div>
              <div className="mb-4">
                <Label>Insurance Plan:</Label>
                <ListOfInsuranceplanName
                  onChange={handleInsuranceplanChange}
                  defaultValue={insuranceplan}
                  clear={clearInsuranceplan}
                />
              </div>
              <div className="mb-4">
                <Label>Payer:</Label>
                <Input
                  value={Payer.join(",")}
                  onChange={(e) => setPayer([e.target.value])}
                  placeholder="Enter Payer"
                />
              </div>
              <div className="mb-4">
                <Label>Doctor:</Label>
                <ListOfDoctorName
                  onChange={handleDoctorChange}
                  defaultValue={doctor}
                  clear={clearDoctor}
                />
              </div>
              <div className="mb-4">
                <Label>Patients:</Label>
                <Patient
                  onChange={handlePatientChange}
                  defaultValue={patients}
                  clear={clearPatient}
                />
              </div>

              <div className="mb-4">
                <Label>Policy:</Label>
                <PolicyNames
                  onChange={handlePoliciesChange}
                  defaultValue={policy}
                  clear={clearPolicy}
                />
              </div>
              <div>
                <Label>User Level:</Label>
                <Input
                  value={userLevel.join(",")}
                  onChange={(e) => setUserLevel([e.target.value])}
                  placeholder="Enter User Level"
                />
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Is Active:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="is_active"
                            value="true"
                            checked={isActive === true}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="is_active"
                            value="false"
                            checked={isActive === false}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>

            {/* Second Column */}
            <div>
              <div className="mb-4">
                <Label htmlFor="FrequencyType">Frequency Type:</Label>
                <select
                  className="form-select"
                  value={frequencyType}
                  onChange={(e) => setFrequencyType(e.target.value)}
                >
                  <option value="">Select an Type</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                  <option value="yearly">Yearly</option>
                </select>
              </div>

              <div className="mb-4">
                <Label htmlFor="SupplyLimit">Quantity Supplied</Label>
                <Input
                  id="SupplyLimit"
                  value={SupplyLimit}
                  onChange={(e) => setSupplyLimit(Number(e.target.value))}
                  placeholder="Enter Quantity Supplied"
                />
              </div>

              <div className="mb-3">
                <Label className="m-2">Dispensed Date :</Label>
                <Input
                  type="date"
                  value={DispensedDate}
                  onChange={(e) => setDispensedDate(e.target.value)}
                  placeholder="Enter Dispensed Date"
                />
              </div>

              <div className={`mb-${hasSelectValue ? "5" : "3"} w-80`}>
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Apply To Vip:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Vip"
                            value="true"
                            checked={apply_to_other_vip === true}
                            onChange={(e) =>
                              setApply_to_other_vip(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Vip"
                            value="false"
                            checked={apply_to_other_vip === false}
                            onChange={(e) =>
                              setApply_to_other_vip(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>
                      Apply To Other Providers?
                    </AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Providers"
                            value="true"
                            checked={applyToOtherProviders === true}
                            onChange={(e) =>
                              setApplyToOtherProviders(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Providers"
                            value="false"
                            checked={applyToOtherProviders === false}
                            onChange={(e) =>
                              setApplyToOtherProviders(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>
                      Apply To Other Networks:
                    </AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Networks"
                            value="true"
                            checked={apply_to_other_networks === true}
                            onChange={(e) =>
                              setApply_to_other_networks(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Networks"
                            value="false"
                            checked={apply_to_other_networks === false}
                            onChange={(e) =>
                              setApply_to_other_networks(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>
                      Apply To Other Insurance Plan:
                    </AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Insurance"
                            value="true"
                            checked={apply_to_other_insuranceplan === true}
                            onChange={(e) =>
                              setapply_to_other_insuranceplan(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Insurance"
                            value="false"
                            checked={apply_to_other_insuranceplan === false}
                            onChange={(e) =>
                              setapply_to_other_insuranceplan(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Apply To Other Payer:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Payer"
                            value="true"
                            checked={apply_to_other_payer === true}
                            onChange={(e) =>
                              setapply_to_other_payer(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Payer"
                            value="false"
                            checked={apply_to_other_payer === false}
                            onChange={(e) =>
                              setapply_to_other_payer(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Apply To Other Doctors:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Doctor"
                            value="true"
                            checked={applyToOtherDoctor === true}
                            onChange={(e) =>
                              setApplyToOtherDoctor(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Doctor"
                            value="false"
                            checked={applyToOtherDoctor === false}
                            onChange={(e) =>
                              setApplyToOtherDoctor(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>
                      Apply To Other Patients:
                    </AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Patients"
                            value="true"
                            checked={apply_to_other_patients === true}
                            onChange={(e) =>
                              setApply_to_other_patients(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Patients"
                            value="false"
                            checked={apply_to_other_patients === false}
                            onChange={(e) =>
                              setApply_to_other_patients(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>
                      Apply To Other Benefit Groups:
                    </AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="policy"
                            value="true"
                            checked={apply_to_other_policy === true}
                            onChange={(e) =>
                              setApply_to_other_policy(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="benefit_group"
                            value="false"
                            checked={apply_to_other_policy === false}
                            onChange={(e) =>
                              setApply_to_other_policy(
                                e.target.value === "true"
                              )
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Apply To Other User:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="user"
                            value="true"
                            checked={apply_to_other_user === true}
                            onChange={(e) =>
                              setApply_to_other_user(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="user"
                            value="false"
                            checked={apply_to_other_user === false}
                            onChange={(e) =>
                              setApply_to_other_user(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
          </div>
          <DialogFooter className="gap-2 m-4">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setEditIndex(null);
                clear();
                setIsDialogOpen(false);
              }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* table */}

      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={[ "relation_name"]}
        addButtonLabel="Add New Relation "
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={deleteItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
      />

      <Toaster />
    </div>
  );
};

export default RefillLimitDrugs;
